import {Pipe, PipeTransform} from '@angular/core';
import {EquipmentAlertType} from 'src/app/shared/enums/equipment-alert-type.enum';

@Pipe({
  name: 'equipmentAlertTypeName',
  standalone: true,
})
export class EquipmentAlertTypeName implements PipeTransform {

  transform(type?: string): string {
    switch (type) {
      case EquipmentAlertType.FUTURE_PASSAGE:
        return 'Passagem no Futuro';

      case EquipmentAlertType.SEND_SERVER_FAIL:
        return 'Falha de Envio ao Servidor';

      case EquipmentAlertType.EQUIPMENT_TO_SERVER_DELAY:
        return 'Atraso de Envio de Equipamento para o Servidor';

      case EquipmentAlertType.DATA_TO_SERVER_DELAY:
        return 'Atraso no Envio de Dados ao Servidor';

      case EquipmentAlertType.LOW_RELIABILITY:
        return 'Baixa Confiabilidade OCR';

      case EquipmentAlertType.LANE_WITHOUT_OCR:
        return 'Faixa sem OCR (por hora)';

      case EquipmentAlertType.SEQUENCE_WITHOUT_OCR:
        return 'Sequência sem OCR';

      default:
        return 'Alerta';
    }
  }
}
